import translation from '../../../../utils/translation';
import fr from './devices.fr.json';
import nl from './devices.nl.json';
import pl from './devices.pl.json';

translation.addResourceBundle('nl', 'global', nl, true, true);
translation.addResourceBundle('fr', 'global', fr, true, true);
translation.addResourceBundle('pl', 'global', pl, true, true);
